@if (showBadges && isPaying) {
  <div class="mr-12 md:pt-4">
    <ng-container *transloco="let t; read: 'findMyAgent.results'">
      <p class="text-heading-3 mb-2">{{ t('badges-title') }}</p>
      <div class="flex w-full gap-x-2">
        @if (badges.isTrustedAgent) {
          <div class="w-[75px]">
            <img [src]="'/assets/images/recognition/recognition-top20.svg' | staticAssetUrl" alt="Trusted Agent" />
          </div>
        }
        @if (badges.isHighlyRecommended) {
          <div class="w-[75px]">
            <img [src]="'/assets/images/recognition/recognition-trusted.svg' | staticAssetUrl" alt="Highly Recommended" />
          </div>
        }
        @if (badges.isAwardWinner) {
          <div class="w-[75px]">
            <img [src]="'/assets/images/recognition/recognition-aoty.svg' | staticAssetUrl" alt="Award Winner" />
          </div>
        }
      </div>
    </ng-container>
  </div>
}
